import { useState } from 'react';
import { Input } from './input';

export const Note = (ps: {
  id: string;
  initialValue?: string;
  onSave(id: string, v: string): void;
}) => {
  const [value, setValue] = useState(ps.initialValue || '');
  const [timer, setTimer] = useState<NodeJS.Timeout>();

  return (
    <Input
      value={value}
      placeholder="Note"
      onChange={(v) => {
        const value = String(v);
        setValue(value);
        if (timer) clearTimeout(timer);
        setTimer(
          setTimeout(() => {
            ps.onSave(ps.id, value);
          }, 1000),
        );
      }}
    />
  );
};
